"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildQuery = exports.addParam = exports.parsePath = void 0;
var for_object_1 = __importDefault(require("./for-object"));
var is_of_type_1 = __importDefault(require("./is-of-type"));
var EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=';
var parsePath = function (href) {
    var output = { href: href };
    var context = typeof global !== 'undefined' ? global : window;
    if (typeof href === 'string' && href.length) {
        if (href.startsWith('//')) {
            href = 'https:' + href;
        }
        if (context.URL) {
            try {
                output = new context.URL(href);
            }
            catch (err) {
                output = {
                    error: true,
                    data: EMPTY_GIF,
                };
            }
        }
        else {
            var match = href.match(/^(?:(https?:)?\/\/)?(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
            if (match) {
                output.protocol = match[1], output.host = match[2], output.hostname = match[3], output.port = match[4], output.pathname = match[5], output.search = match[6], output.hash = match[7];
            }
            else {
                output = {
                    error: true,
                    data: EMPTY_GIF,
                };
            }
        }
    }
    else {
        output = {
            href: '',
        };
    }
    return output;
};
exports.parsePath = parsePath;
var addParam = function (inTarget, name, value, encode, withQuestion) {
    var target = inTarget;
    if (is_of_type_1.default.s(target) && target.length) {
        if (withQuestion) {
            if (!(/\?/).test(target)) {
                target += '?';
            }
            target += (/(\?|&)$/.test(target) ? '' : '&');
        }
        else {
            target += (target.substr(-1) !== '?' ? '&' : '');
        }
    }
    else {
        target = '';
    }
    if (name) {
        target += name;
        if (value !== null && value !== undefined) {
            target += "=".concat(encode ? encodeURIComponent(value) : value);
        }
    }
    return target;
};
exports.addParam = addParam;
var buildQuery = function (inQuery, pars, noEncode) {
    var query = inQuery;
    if (pars && is_of_type_1.default.o(pars)) {
        (0, for_object_1.default)(pars, function (prop) {
            query = (0, exports.addParam)(query, prop, pars[prop], !!(Array.isArray(noEncode) && (noEncode.indexOf(prop) > -1)));
        });
    }
    return query;
};
exports.buildQuery = buildQuery;
